import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const RequestApplyIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 1.56C7.25 1.25072 7.4552 1 7.70833 1H12.2917C12.5448 1 12.75 1.25072 12.75 1.56V3.24C12.75 3.54928 12.5448 3.8 12.2917 3.8H7.70833C7.4552 3.8 7.25 3.54928 7.25 3.24V1.56Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.5H6V3.5C6 4.32843 6.67157 5 7.5 5H12.5C13.3284 5 14 4.32843 14 3.5V2.5H14.5C15.8807 2.5 17 3.61929 17 5V16.5C17 17.8807 15.8807 19 14.5 19H5.5C4.11929 19 3 17.8807 3 16.5V5C3 3.61929 4.11929 2.5 5.5 2.5ZM10.0001 7.5C10.4383 7.5 10.7936 7.85528 10.7936 8.29355V10.8066H13.3064C13.7446 10.8066 14.0999 11.1619 14.0999 11.6002C14.0999 12.0384 13.7446 12.3937 13.3064 12.3937H10.7936V14.9065C10.7936 15.3447 10.4383 15.7 10.0001 15.7C9.5618 15.7 9.20651 15.3447 9.20651 14.9065V12.3937H6.69345C6.25519 12.3937 5.8999 12.0384 5.8999 11.6002C5.8999 11.1619 6.25519 10.8066 6.69345 10.8066H9.20651V8.29355C9.20651 7.85528 9.5618 7.5 10.0001 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RequestApplyIcon;
